module.exports = __webpack_public_path__ + "img/arrow-right.bbb36f4e.svg";